export default "__VITE_ASSET__d1d76a70__"